<template>
  <div class="faq-menu-block">
    <div class="faq-menu-block__title">{{ title }}</div>

    <div v-if="sortedChildren?.length" class="faq-menu-block__links">
      <a
        v-for="child in sortedChildren"
        :key="child.id"
        :href="getLink(child.url)"
        :class="{ 'faq-menu-block__active-link': isActive(getLink(child.url)) }"
      >
        {{ child.title }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IFaqMenuBlock } from '@/components/FAQ/types';
import useSiteInfo from '@/composables/use-site-info';
import { computed } from 'vue';
import { sortByPriority } from '@/utils/arrays.utils';
import { usePageContext } from '@/composables/use-page-context';

const props = defineProps<IFaqMenuBlock>();

const pageContext = usePageContext();

const sortedChildren = computed(() => {
  return sortByPriority(props.children || []);
});

const { getLinkWithLocale } = useSiteInfo();

const getLink = (url = '/') => {
  return getLinkWithLocale(`faq/${url}`);
};

const isActive = (url: string) => {
  const { urlPathname } = pageContext;

  return urlPathname === url;
};
</script>

<style lang="scss" scoped>
.faq-main {
  .faq-menu-block {
    max-width: 100%;

    &__title {
      @include media-min-lg {
        @include headline-4;
      }
    }

    &__links > a {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
    }
  }
}

.faq-menu-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: $Peak;
  max-width: 242px;

  &__title {
    @include headline-5;
  }

  &__links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    > a {
      color: $Bottom;
      cursor: pointer;
      text-decoration: none;

      @include body-2;

      @include media-min-lg {
        @include media-hover {
          color: $Primary_Active;
        }
      }
    }

    .faq-menu-block__active-link {
      @include headline-7;
    }
  }
}
</style>
